import { EApiDispositionId } from "utils/offer";
import { QueryValues } from "./queries";

export interface IDispositionItemConfig {
  translationId: string;
  queryValue: keyof (typeof QueryValues)["dispositions"];
  apiIds: Array<EApiDispositionId>;
  availableInSearch: boolean;
  availableInOfferInsertion: boolean;
  dataTest: string;
}

export const DISPOSITIONS: Array<IDispositionItemConfig> = [
  {
    translationId: "1+kk",
    queryValue: "disposition.1+kk",
    apiIds: [EApiDispositionId.RENT_1_PLUS_KK],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "1+kk",
  },
  {
    translationId: "1+1",
    queryValue: "disposition.1+1",
    apiIds: [EApiDispositionId.RENT_1_PLUS_1],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "1+1",
  },
  {
    translationId: "2+kk",
    queryValue: "disposition.2+kk",
    apiIds: [EApiDispositionId.RENT_2_PLUS_KK],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "2+kk",
  },
  {
    translationId: "2+1",
    queryValue: "disposition.2+1",
    apiIds: [EApiDispositionId.RENT_2_PLUS_1],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "2+1",
  },
  {
    translationId: "3+kk",
    queryValue: "disposition.3+kk",
    apiIds: [EApiDispositionId.RENT_3_PLUS_KK],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "3+kk",
  },
  {
    translationId: "3+1",
    queryValue: "disposition.3+1",
    apiIds: [EApiDispositionId.RENT_3_PLUS_1],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "3+1",
  },
  {
    translationId: "4+kk",
    queryValue: "disposition.4+kk",
    apiIds: [EApiDispositionId.RENT_4_PLUS_KK],
    availableInSearch: true,
    availableInOfferInsertion: false,
    dataTest: "4+kk",
  },
  {
    translationId: "4+1",
    queryValue: "disposition.4+1",
    apiIds: [EApiDispositionId.RENT_4_PLUS_1],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "4+1",
  },
  {
    translationId: "5+kk",
    queryValue: "disposition.5+kk",
    apiIds: [EApiDispositionId.RENT_5_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "5+kk",
  },
  {
    translationId: "5+1",
    queryValue: "disposition.5+1",
    apiIds: [EApiDispositionId.RENT_5_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "5+1",
  },
  {
    translationId: "6+kk",
    queryValue: "disposition.6+kk",
    apiIds: [EApiDispositionId.RENT_6_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "6+kk",
  },
  {
    translationId: "6+1",
    queryValue: "disposition.6+1",
    apiIds: [EApiDispositionId.RENT_6_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "6+1",
  },
  {
    translationId: "7+kk",
    queryValue: "disposition.7+kk",
    apiIds: [EApiDispositionId.RENT_7_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "7+kk",
  },
  {
    translationId: "7+1",
    queryValue: "disposition.7+1",
    apiIds: [EApiDispositionId.RENT_7_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "7+1",
  },
  {
    translationId: "Atypický",
    queryValue: "disposition.atypical",
    apiIds: [EApiDispositionId.RENT_ATYPICAL],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "atypical",
  },
  {
    translationId: "Dům",
    queryValue: "disposition.house",
    apiIds: [EApiDispositionId.RENT_HOUSE],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "house",
  },
  {
    translationId: "Spolubydlení",
    queryValue: "disposition.coliving",
    apiIds: [
      // EApiDispositionId.COHABITING_1_BED,
      // EApiDispositionId.COHABITING_2_BEDS,
      // EApiDispositionId.COHABITING_3_BEDS,
      // EApiDispositionId.COHABITING_4_AND_MORE_BEDS,
      EApiDispositionId.COHABITING_STANDALONE_ROOM,
      EApiDispositionId.COHABITING_SHARED_ROOM,
    ],
    availableInSearch: true,
    availableInOfferInsertion: true,
    dataTest: "coliving",
  },
  {
    translationId: "Jednopokojový",
    queryValue: "disposition.oneRoom",
    apiIds: [EApiDispositionId.SALE_ONE_ROOM],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "oneRoom",
  },
  {
    translationId: "6+kk",
    queryValue: "disposition.6PlusKk",
    apiIds: [EApiDispositionId.SALE_6_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "6PlusKk",
  },
  {
    translationId: "5+1",
    queryValue: "disposition.5Plus1",
    apiIds: [EApiDispositionId.SALE_5_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "5Plus1",
  },
  {
    translationId: "5+kk",
    queryValue: "disposition.5PlusKk",
    apiIds: [EApiDispositionId.SALE_5_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "5PlusKk",
  },
  {
    translationId: "4+1",
    queryValue: "disposition.4Plus1",
    apiIds: [EApiDispositionId.SALE_4_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "4Plus1",
  },
  {
    translationId: "4+kk",
    queryValue: "disposition.4PlusKk",
    apiIds: [EApiDispositionId.SALE_4_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "4PlusKk",
  },
  {
    translationId: "3+1",
    queryValue: "disposition.3Plus1",
    apiIds: [EApiDispositionId.SALE_3_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "3Plus1",
  },
  {
    translationId: "3+kk",
    queryValue: "disposition.3PlusKk",
    apiIds: [EApiDispositionId.SALE_3_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "3PlusKk",
  },
  {
    translationId: "2+1",
    queryValue: "disposition.2Plus1",
    apiIds: [EApiDispositionId.SALE_2_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "2Plus1",
  },
  {
    translationId: "2+kk",
    queryValue: "disposition.2PlusKk",
    apiIds: [EApiDispositionId.SALE_2_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "2PlusKk",
  },
  {
    translationId: "1+1",
    queryValue: "disposition.1Plus1",
    apiIds: [EApiDispositionId.SALE_1_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "1Plus1",
  },
  {
    translationId: "1+kk",
    queryValue: "disposition.1PlusKk",
    apiIds: [EApiDispositionId.SALE_1_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "1PlusKk",
  },
  {
    translationId: "7+kk",
    queryValue: "disposition.7PlusKk",
    apiIds: [EApiDispositionId.SALE_7_PLUS_KK],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "7PlusKk",
  },
  {
    translationId: "Atypický",
    queryValue: "disposition.atypical",
    apiIds: [EApiDispositionId.SALE_ATYPICAL],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "atypical",
  },
  {
    translationId: "Více než pět pokojů",
    queryValue: "disposition.fivePlusRooms",
    apiIds: [EApiDispositionId.SALE_FIVE_PLUS_ROOMS],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "fivePlusRooms",
  },
  {
    translationId: "Čtyřpokojový",
    queryValue: "disposition.fourRooms",
    apiIds: [EApiDispositionId.SALE_FOUR_ROOMS],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "fourRooms",
  },
  {
    translationId: "Třípokojový",
    queryValue: "disposition.threeRooms",
    apiIds: [EApiDispositionId.SALE_THREE_ROOMS],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "threeRooms",
  },
  {
    translationId: "Dvoupokojový",
    queryValue: "disposition.twoRooms",
    apiIds: [EApiDispositionId.SALE_TWO_ROOMS],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "twoRooms",
  },
  {
    translationId: "6+1",
    queryValue: "disposition.6Plus1",
    apiIds: [EApiDispositionId.SALE_6_PLUS_1],
    availableInSearch: false,
    availableInOfferInsertion: true,
    dataTest: "6Plus1",
  },
];

export const DISPOSITION_MAP = new Map(
  DISPOSITIONS.map((item) => [item.queryValue, item]),
);
